import React, { useState } from "react";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/layout/Spinner";
import BlogcommentForm from "../../components/blogcomments/BlogcommentForm";
import { convertToFormData } from "../../shared/upload";
import {
    initialValues,
    inputFields,
    PAGE_TITLE,
    PAGE_SINGLE_TITLE,
    LINK_URL,
} from "../../shared/enums/blogcomments_enum";
import {
    useUpdateBlogcomment,
    useSingleBlogcomment,
    useGetDropdownOptions,
} from "../../shared/hooks/UseBlogcomment";
// import { useSelectAllBlogcomment } from "../../shared/hooks/UseBlogcomment";

const EditBlogcomment = ({ match }) => {
    let history = useHistory();
    const [single_data] = useSingleBlogcomment(match.params.id);
    const [updateData] = useUpdateBlogcomment();
    const { blogcomment_loading, blogcomment, edit_blogcomment_loading } = single_data;
    const [featuredImage, setFeaturedImage] = useState(null);

    const [dropdownOptions, loadOptions] = useGetDropdownOptions();
    const submitFormClicked = async (values) => {
        await updateData(blogcomment._id, values);
        history.push(`/${LINK_URL}/${blogcomment._id}/view`);
    };

    return (
        <div className="pace-done">
            <div>
                <Header />
                <BreadCrumb
                    title={`Edit ${PAGE_SINGLE_TITLE}`}
                    mainLinkTitle={PAGE_TITLE}
                    mainLinkUrl={LINK_URL}
                    activeLink="Edit"
                />
            </div>
            <div className="container-fluid">
                <div className="col-lg-12">
                    <div className="card">
                        {!blogcomment_loading ? (
                            blogcomment && (
                                <div>
                                    <div className="card-header">
                                        <div>
                                            <h4 className="card-title">
                                                {blogcomment[Object.keys(inputFields)[0]]} - <span>Edit</span>{" "}
                                            </h4>
                                            <p className="card-title-desc">
                                                <Link
                                                    to={`/${LINK_URL}`}
                                                    className="btn btn-soft-light"
                                                >
                                                    <i className="fa fa-angle-left"></i> {PAGE_TITLE}
                                                </Link>
                                                <Link
                                                    to={`/${LINK_URL}/${blogcomment._id}/view`}
                                                    className="btn btn-soft-light"
                                                >
                                                    <i className="fa fa-eye"></i>
                                                </Link>
                                            </p>
                                        </div>
                                    </div>
                                    <BlogcommentForm
                                        data={blogcomment}
                                        edit={true}
                                        featuredImage={featuredImage}
                                        setFeaturedImage={setFeaturedImage}
                                        submitForm={submitFormClicked}
                                        inputFields={inputFields}
                                        initialValues={initialValues}
                                        dropdown_options={dropdownOptions}
                                        loading={edit_blogcomment_loading}
                                        loadOptions={loadOptions}
                                    />
                                </div>
                            )
                        ) : (
                            <div className="text-center">
                                <Spinner />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditBlogcomment;
